import React from "react";

class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value ? this.props.value : ""
        }
        this.onInputChange = this.onInputChange.bind(this);
    }
    onInputChange(event) {
        var value = event.target.value;
        this.props.onChange(value)
        this.setState({ value })
    }
    render() {
        var { onChange, rows, className, error, ...newProps } = this.props;
        return (
            <textarea onChange={this.onInputChange} value={this.state.value} {...newProps} rows={rows ? rows : "3"}
                className={error ? "block w-full text-sm bg-white border border-red-400 rounded-[11px] py-3 px-3.5 focus:outline-none transition-colors"
                    : "block w-full text-sm bg-white border rounded-[11px] py-3 px-3.5 focus:outline-none transition-colors"}
                style={!error ? { borderColor: '#e7eaef' } : {}} />
        )
    }
}

export default TextArea;